import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { trackAddToCart, trackInitiateCheckout } from '../utils/metaPixel';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  fullWidth?: boolean;
  href?: string;
}
export function CTAButton({
  children,
  onClick,
  className = '',
  fullWidth = false,
  href
}: CTAButtonProps) {
  const handleClick = () => {
    if (href) {
      trackAddToCart();
      trackInitiateCheckout();
      setTimeout(() => {
        window.open(href, '_blank', 'noopener,noreferrer');
      }, 300);
    } else if (onClick) {
      onClick();
    } else {
      const pricingSection = document.getElementById('precio');
      if (pricingSection) {
        pricingSection.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <motion.button whileHover={{
    scale: 1.02,
    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)'
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`
        bg-[#C94040] text-[#F5F0E8] font-bold py-4 px-8 rounded-lg shadow-lg
        text-xl md:text-2xl transition-colors duration-200 hover:bg-[#b03535]
        flex items-center justify-center gap-2
        ${fullWidth ? 'w-full' : 'w-full md:w-auto'}
        ${className}
      `} aria-label="Comprar el plan de 14 días" data-id="element-21">
      <span data-id="element-22">{children}</span>
      <ArrowRight className="w-6 h-6" data-id="element-23" />
    </motion.button>;
}